export const NIA_GAMES = ["Move-It", "PingWins", "Two-Flags", "MaxIt", "ClimbUp", "Blocker"];
